export const VIEW_STATES = {
    FORM: 'FORM',
    ITEM_ENDED: 'ITEM_ENDED',
    LOADING: 'LOADING',
    SUBMIT_FAILED: 'SUBMIT_FAILED',
    SUBMIT_SUCCESS: 'SUBMIT_SUCCESS',
    SUBMITTING: 'SUBMITTING'
};

export const REASONS = {
    NONE: '0',
    SUSPECTED_FRAUD: '1',
    ITEM_IS_A_COUNTERFEIT: '2',
    BRAND_NAME_MISUSE: '3',
    WRONG_CATEGORY: '4',
    PROHIBITED_SHIPPINGvOR_PAYMEN_TMETHOD: '5',
    OTHER_PROHIBITED_ITEM: '6',
    OTHER_PROHIBITED_SETUP: '7',
    OTHER: '8'
};
